export default __webpack_public_path__ + "locales/it/Settings.json?hash=093a064a195055db6bbf900037bc1b3a";